import he from "he";

export function htmlToPlainText(html: string): string {
    if (!html) return "";

    // decode entity (&nbsp;, &amp;, &lt; ฯลฯ)
    let text = he.decode(html);

    // แปลง <br> เป็น \n
    text = text.replace(/<br\s*\/?>/gi, "\n");

    // แปลง <p> เป็นขึ้นบรรทัดใหม่
    text = text.replace(/<\/p>/gi, "\n\n");

    // ตัด tag อื่นๆ ออก
    text = text.replace(/<\/?[^>]+(>|$)/g, "");

    // trim ช่องว่างเกิน
    return text.trim();
}
